module.exports = __webpack_public_path__ + "img/20190924154143249.19532597.jpg";